import { render, staticRenderFns } from "./CoWeekdaySelector.vue?vue&type=template&id=4ab22c36&scoped=true&"
import script from "./CoWeekdaySelector.vue?vue&type=script&lang=ts&"
export * from "./CoWeekdaySelector.vue?vue&type=script&lang=ts&"
import style0 from "./CoWeekdaySelector.vue?vue&type=style&index=0&id=4ab22c36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab22c36",
  null
  
)

export default component.exports